import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-abrechnungsform',
  templateUrl: './abrechnungsform.component.html',
  styleUrls: ['./abrechnungsform.component.scss']
})
export class AbrechnungsformComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
